var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.taskListData.length)?_c('task-list-metrics-table',{attrs:{"agg-stream":_vm.aggStream,"table-user-settings":_vm.taskListTableUserSettings,"task-list-data":_vm.taskListData,"segments-map":_vm.segmentsMap,"csv-config":_vm.csvConfig},on:{"tableSettingsUpdate":_vm.updateTaskListTableSettings,"onMetricClick":_vm.openDrawerAndFetchData}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }